<script setup>
import Button from "@/Components/Button.vue";
import { ArrowDownTrayIcon } from "@heroicons/vue/20/solid";
import { computed, onMounted, ref } from "vue";

const props = defineProps({
    track: Object,
    user_order: Object | null,
});

// Only Android has the RBR app. Read in onMounted: SSR has no navigator.
const isAndroid = ref(false);
onMounted(() => {
    isAndroid.value = /Android/i.test(navigator.userAgent);
});

// Chrome keeps a link to the same site in the browser, so a plain /t/ link would only reload the
// website. An intent: URL opens the app; without the app (or an old one), it opens Google Play.
const openInAppUrl = computed(() => {
    const playStore = "https://play.google.com/store/apps/details?id=com.roadbookrally.rbrr";
    return (
        `intent://roadbookrally.com/t/${encodeURIComponent(props.track.pin)}` +
        `#Intent;scheme=https;package=com.roadbookrally.rbrr;S.browser_fallback_url=${encodeURIComponent(playStore)};end`
    );
});

function myAlert() {
    alert("You need to purchase this track first before accessing it.");
}
</script>

<template>
    <span v-if="isAndroid">
        <Button
            v-if="track.pricing === 'paid' && user_order === null"
            class="h-6 disabled:opacity-50"
            hint="You need to pay for this track first."
            @click="myAlert()"
            >Open in app
        </Button>
        <Button
            v-else
            class="h-6"
            target="_self"
            :href="openInAppUrl"
            ><ArrowDownTrayIcon
                class="-ml-0.5 mr-1.5 size-4"
                aria-hidden="true"
            />Open in app
        </Button>
    </span>
</template>
